import React, { useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import mermaid from "mermaid";

function sanitizeMermaid(code: string): string {
  return code.replace(/\[([^\]]+)\]/g, (_, label) => {
    const safeLabel = label
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)")
      .replace(/>/g, "\\>")
      .replace(/</g, "\\<")
      .replace(/&/g, "\\&");
    return `[${safeLabel}]`;
  });
}


const MarkdownWithMermaid = ({ content }: { content: string }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    mermaid.initialize({
      startOnLoad: false,
      themeVariables: {
        primaryColor: "#ffffff",
        edgeLabelBackground: "#ffffff",
        fontSize: "14px",
        nodeSpacing: "10px",
        edgeLength: "50px",
      },
    });

    const mermaidElements = containerRef.current.querySelectorAll(".mermaid");

    mermaidElements.forEach(async (el, index) => {
      const rawCode = el.textContent || "";
      const code = sanitizeMermaid(rawCode);

      const id = `mermaid-${index}-${Math.random().toString(36).slice(2, 7)}`;

      try {
        const { svg } = await mermaid.render(id, code);
        el.innerHTML = svg;
      } catch (err: any) {
        el.innerHTML = `<pre style="color: red;">Mermaid render error: ${err.message}</pre>`;
        console.error("Mermaid render error:", err);
      }
    });
  }, [content]);

  return (
    <div ref={containerRef}>
      <ReactMarkdown
        components={{
          code({ className, children }) {
            if (className?.includes("language-mermaid")) {
              return <div className="mermaid">{String(children).trim()}</div>;
            }
            return (
              <pre className={className}>
                <code>{children}</code>
              </pre>
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownWithMermaid;
